import React from 'react';
import { clamp } from '../../engine/stats';

interface SensorCardProps {
  name: string;
  metric: string;
  value: string;
  zScore: number;
  active: boolean;
}

export function SensorCard({ name, metric, value, zScore, active }: SensorCardProps) {
  const absZ = Math.abs(zScore);
  const statusClass = !active ? 'off' : absZ >= 2.0 ? 'bad' : absZ >= 1.5 ? 'warn' : 'ok';
  const barPct = clamp(absZ / 4 * 100, 0, 100);
  const barColor = absZ >= 2.0 ? 'var(--red)' : absZ >= 1.5 ? 'var(--yellow)' : 'var(--green)';

  return (
    <div className="sensor-card">
      <div className="s-head">
        <span className="s-name">{name}</span>
        <span className={`s-status ${statusClass}`} />
      </div>
      <div className="s-metric">{metric}</div>
      <div className="s-val">{value}</div>
      <div className="s-zbar">
        <div className="s-zbar-fill" style={{ width: `${barPct}%`, background: barColor }} />
      </div>
    </div>
  );
}
